// @flow

const i18n = {
  _(str) {
    /* eslint-disable no-console */
    console.error(
      'i18n is being called without i18n context being initialized and will cause unexpected behavior. This typically happens when you call it outside of a React Component. Move this call inside of a component. You can view the stack trace below:',
    );
    console.trace();
    /* eslint-enable no-console */
    return str;
  },
  set(_i18n) {
    Object.assign(this, _i18n);
  },
};

export type I18nType = {
  _: (str: string, context?: string) => string,
  ngettext: (singular: string, plural: string, count: number, context?: string) => string,
  getHumanizedTimesince: (
    time: string,
    options?: { isAbbreviated?: boolean, skipSeconds?: boolean },
  ) => string,
  set(_i18n: any): void,
  getLocaleData(): {
    i18nStrings: Object,
    locale: string,
    plural: (n: number) => boolean,
  },
  commonStrings: { [key: string]: string },
  getPluralFunction: (localeCode: string) => (count: number) => boolean,
};

export default ((i18n: any): I18nType);
